import styled, { keyframes } from 'styled-components';
import { ReactComponent as MenuIcon } from '../../../assets/icons/menu-icon.svg';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg';

const iconOut = keyframes`
  from {
    opacity: 1;
    transform: rotate(0deg);
  }
  to {
    opacity: 0;
    transform: rotate(-180deg);
  }
`;

const iconIn = keyframes`
  from {
    opacity: 0;
    transform: rotate(180deg);
  }
  to {
    opacity: 1;
    transform: rotate(0deg);
  }
`;

export const MobileHeaderContainer = styled.div`
  display: none;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
  height: ${props => (props.$active ? '28.156rem' : '6rem')};
  transition: all 0.3s ease-in-out;
  padding: 2rem 2rem;
  background: #484888;
  z-index: 5000;
  @media (max-width: 875px) {
    display: flex;
  }
`;
export const Row = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: row;
  height: 2rem;
  gap: 2rem;
  @media (max-width: 430px) {
    justify-content: space-between;
  }
`;
export const Menu = styled(MenuIcon)`
  cursor: pointer;

  display: none;

  transition: all 0.2s ease-in-out;
  animation: ${props => (props.$active ? iconIn : iconOut)} 0.2s ease-in-out;
  @media (max-width: 430px) {
    display: flex;
  }
`;
export const Close = styled(CloseIcon)`
  cursor: pointer;
  fill: white;
  display: none;
  transition: all 0.2s ease-in-out;
  animation: ${props => (!props.$active ? iconIn : iconOut)} 0.2s ease-in-out;
  @media (max-width: 430px) {
    display: flex;
  }
`;

export const RelativeIcon = styled.div`
  width: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const NavLinks = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  @media (max-width: 430px) {
    display: none;
  }
`;

export const StyledNavLinks = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;

  opacity: ${props => (props.$active ? 1 : 0)};
`;

export const Link = styled.span`
  font-family: 'Avenir-Medium';
  color: #fff;
  text-transform: capitalize;

  border-radius: 2rem;
  background: ${props => (props.$active ? 'rgba(255, 255, 255, 0.2)' : 'transparent')};
  cursor: pointer;
  user-select: none;
  transition: all 0.3s ease-in-out;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  &:active {
    opacity: 0.45;
  }
  font-size: 1.6rem;
  padding: 0.8rem;
`;

export const LogoutDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  margin-top: auto;

  transition: all 0.3s ease-in-out;

  &:active {
    opacity: 0.45;
  }
`;

export const Logout = styled.span`
  font-family: 'Avenir-Medium';
  color: #fff;
  user-select: none;
  text-transform: capitalize;

  border-radius: 2rem;

  cursor: pointer;
  font-size: 1.6rem;
  padding: 0.8rem;
  transition: all 0.3s ease-in-out;
`;
